export const apiFetch = (input, init = {}) => {
  return fetch(input, {
    ...init,
  });
};
